import { Component, OnInit } from "@angular/core";
import { Tabs } from "../contribution/tabs";

@Component({
    selector: "ngx-terms",
    templateUrl: "./terms.component.html",
    styleUrls: ["./terms.component.scss"],
})
export class TermsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
